// import axios from "axios";
// import VueCookies from "vue-cookies";
// import configuration from "@/utils/configuration";
// axios.interceptors.request.use(
//   (config) => {
//     if (
//       config.url &&
//       config.url.includes('/refresh') &&
//       config.headers.Authorization
//     ) {
//       return config;
//     }
//     const token = VueCookies.get("access_token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// const loginModules = {
//   namespaced: true,
//   state: {
//     user: JSON.parse(localStorage.getItem("user")) || null,
//     isLogin: !!VueCookies.get("access_token"),
//     errorMessage: null,
//     loading: false,
//   },
//   getters: {
//     isLoading: (state) => state.loading,
//     isLogin: (state) => state.isLogin,
//     getUser: (state) => state.user,
//     getErrorMessage: (state) => state.errorMessage,
//   },
//   mutations: {
//     setUser(state, { user }) {
//       state.user = user;
//       localStorage.setItem("user", JSON.stringify(user));
//       state.isLogin = true;
//     },
//     clearUser(state) {
//       state.user = null;
//       localStorage.removeItem("user");
//       state.isLogin = false;
//     },
//     setError(state, message) {
//       state.errorMessage = message;
//     },
//     clearError(state) {
//       state.errorMessage = null;
//     },
//     setLoading(state, loading) {
//       state.loading = loading;
//     },
//   },
//   actions: {
//     async loginUser({ commit }, credentials) {
//       const { username, password } = credentials;
//       commit("setLoading", true);
//       try {
//         const response = await axios.post(
//           `${configuration.authUrl}/login`,
//           { username, password },
//           {
//             headers: { "Content-Type": "application/json" },
//           }
//         );

//         const { data } = response;

//         if (data.statusCode === 201) {
//           const { access_token, refresh_token } = data.data;

//           if (!access_token || !refresh_token) {
//             throw new Error("Invalid response: Missing tokens");
//           }
//           VueCookies.set("access_token", access_token);
//           VueCookies.set("refresh_token", refresh_token);
//           commit("setUser", { user: username });
//           commit("clearError");
//         } else {
//           throw new Error(`Unexpected status code: ${data.statusCode}`);
//         }
//       } catch (error) {
//         const message =
//           error.response?.data?.message || error.message || "loginUser Failed";
//         commit("setError", message);
//         throw error;
//       } finally {
//         commit("setLoading", false);
//       }
//     },

//     async fetchUserProfile({ commit }) {
//       try {
//         const accessToken = VueCookies.get("access_token");

//         if (!accessToken) {
//           throw new Error("Access token not found.");
//         }

//         const response = await axios.get(
//           `${configuration.backUrl}/users/profile`,
//           {
//             headers: { Authorization: `Bearer ${accessToken}` },
//           }
//         );

//         const { data } = response;

//         if (!data || !data.user) {
//           throw new Error("Failed to fetch user profile.");
//         }

//         commit("setUser", { user: data.user });
//       } catch (error) {
//         if (process.env.NODE_ENV === "development") {
//           console.error("Failed to fetch user profile:",error.message || error);
//         }
//         throw error;
//       }
//     },

//     async refreshToken({ commit }) {
//       try {
//         const refreshToken = VueCookies.get("refresh_token");

//         if (!refreshToken) {
//           throw new Error("Refresh token not found.");
//         }
//         const response = await axios.post(
//           `${configuration.authUrl}/refresh`,
//           null,
//           {
//             headers: {
//               Authorization: `Bearer ${refreshToken}`,
//             },
//           }
//         );
//         const { data } = response;
//         if (data.statusCode === 201) {
//           const { access_token } = data.data;
//           if (!access_token) {
//             throw new Error("Failed to refresh access token.");
//           }
//           VueCookies.set("access_token", access_token);
//         } else {
//           throw new Error(`Unexpected status code: ${data.statusCode}`);
//         }
//       } catch (error) {
//         commit("clearUser");
//         throw error;
//       }
//     },
//     async logoutUser({ commit }) {
//       commit("setLoading", true);
//       try {
//         const { data } = await axios({
//           method: "POST",
//           url: `${configuration.authUrl}/logout`,
//           withCredentials: true,
//         });
//         await commit("clearUser");
//         await commit("notificationModules/CLEAR_NOTIFICATIONS", null, {
//           root: true,
//         });
//         VueCookies.remove("access_token");
//         VueCookies.remove("refresh_token");
//         VueCookies.remove("access_token_expires");
//         return data.data;
//       } catch (error) {
//         await commit("clearUser");
//         await commit("notificationModules/CLEAR_NOTIFICATIONS", null, {
//           root: true,
//         });
//         VueCookies.remove("access_token");
//         VueCookies.remove("refresh_token");
//         VueCookies.remove("access_token_expires");
//       } finally {
//         commit("setLoading", false);
//       }
//     },
//     setLoading({ commit }, loading) {
//       commit("setLoading", loading);
//     },
//   },
// };
// export default loginModules;

import axios from "axios";
import configuration from "@/utils/configuration";

const loginModules = {
  namespaced: true,
  state: {
    user: JSON.parse(localStorage.getItem("user")) || null,
    isLogin: false,
    errorMessage: null,
    loading: false,

  },
  getters: {
    isLoading: (state) => state.loading,
    isLogin: (state) => state.isLogin,
    getUser: (state) => state.user,
    getErrorMessage: (state) => state.errorMessage,
  },
  mutations: {
    setUser(state, { user }) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
      state.isLogin = true;
    },
    clearUser(state) {
      state.user = null;
      localStorage.clear("user");
      state.isLogin = false;
    },
    setError(state, message) {
      state.errorMessage = message;
    },
    clearError(state) {
      state.errorMessage = null;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },

  },
  actions: {
    async loginUser({ commit }, credentials) {
      const { username, password } = credentials;
      commit("setLoading", true);
      try {
        const response = await axios.post(
          `${configuration.authUrl}/login`,
          { username, password },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true
          }
        );
        const { data } = response;
        if (data.statusCode === 201) {
          commit("setUser", { user: username });
          commit("clearError");
        } else {
          throw new Error(`Unexpected status code: ${data.statusCode}`);
        }
      } catch (error) {
        const message = error.response?.data?.message || error.message || "loginUser Failed";
        commit("setError", message);
        throw new Error(error.message || error);
      } finally {
        commit("setLoading", false);
      }
    },

    async fetchUserProfile({ commit }) {
      try {
        const response = await axios.get(`${configuration.backUrl}/users/profile`, {
          withCredentials: true
        });

        const { data } = response;

        if (!data || !data.user) {
          throw new Error("Failed to fetch user profile.");
        }

        commit("setUser", { user: data.user });
      } catch (error) {
        console.log(error)
      }
    },

    async logoutUser({ commit }) {
      commit("setLoading", true);
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.authUrl}/logout`,
          withCredentials: true,
        });
        await commit("clearUser");
        return data.data;
      } catch (error) {
        await commit("clearUser");
        await commit("notificationModules/CLEAR_NOTIFICATIONS", null, { root: true });
      }
      finally{
        commit("setLoading", false);
      }
    },
    setLoading({ commit }, loading) {
      commit("setLoading", loading);
    },

  },
};

export default loginModules;

